class CheckboxPrivacy extends HTMLElement {
    // Costruttore
    constructor() {
        // Chiamo la super classe per accedere alle proprietà dell'HTMLElement
        super();        
        this.initComponent();
    }

    initComponent() {        
        var checkIsAzienda = document.getElementById('checkbox_azienda');
        var sdi = document.getElementById('sdi');        
        var checkPrivacy = document.getElementById('check_privacy');        
        checkPrivacy.addEventListener('change', (event) => {            
            if (checkIsAzienda.checked) {
                if (event.currentTarget.checked && !this.fieldIsEmpty(sdi)) {
                    this.setEnabledCheckoutButton();
                    return;
                } else {
                    this.setDisabledCheckoutButton();                
                    return;
                }
            } else {
                if (event.currentTarget.checked) {
                    this.setEnabledCheckoutButton();
                    return;
                } else {
                    this.setDisabledCheckoutButton();
                    return;
                }    
            }
        });
    }

    // Metodo per abilitare il bottone di checkout nella pagina carrello
    setEnabledCheckoutButton() {
        var btnCheckoutCart = document.getElementById('checkout');
        btnCheckoutCart.removeAttribute('disabled', 'disabled');        
    }

    // Metodo per disabilitare il bottone di checkout nella pagina carrello
    setDisabledCheckoutButton() {
        var btnCheckoutCart = document.getElementById('checkout');
        btnCheckoutCart.setAttribute('disabled', 'disabled');        
    }

    // Metodo per controllare se un campo input è vuoto
    fieldIsEmpty(inputElement) {
        if (inputElement.value.length == 0) {             
            return true; 
        }  	
        return false; 
    }

}

// Definizione del componente
customElements.define('checkbox-privacy', CheckboxPrivacy);